export default __webpack_public_path__ + "static/media/762.6266b3b1.png";